import {BaseCachedService} from './Core/BaseCachedService';

class GroupingMethodService extends BaseCachedService {
    get Url() { return super.Url + "/groupingMethods"; }
}

export const service = new GroupingMethodService();

